/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

export const styles:any[] = ['.progress[_ngcontent-%COMP%] {margin-bottom:0}\r\n.progress-bar[_ngcontent-%COMP%] {width:100%}'];


// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/components/loading.component.css.shim.ngstyle.ts